/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Tr_12_QInputs */

const en_tut_tr_12_q = /** @type {(inputs: Tut_Tr_12_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Digital Deputy is not answering.`)
};

const id_tut_tr_12_q = /** @type {(inputs: Tut_Tr_12_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wakil Digital saya tidak menjawab.`)
};

/**
* | output |
* | --- |
* | "My Digital Deputy is not answering." |
*
* @param {Tut_Tr_12_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_tr_12_q = /** @type {((inputs?: Tut_Tr_12_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Tr_12_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_tr_12_q(inputs)
	return en_tut_tr_12_q(inputs)
});